import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Autoplay, Navigation } from 'swiper'
import Button from 'components/Base/Button'
import * as styles from './index.module.less'
import classnames from 'classnames'

SwiperCore.use([Autoplay, Navigation])
interface CaseShareProps {
  className?: string
  dataSource: any
}

const CaseShare: React.FC<CaseShareProps> = ({ className, dataSource }) => {
  const { section_one, btn_more_link, btn_more_text = '', section_two = '' } = dataSource
  return (
    <>
      {/* pc */}
      <div className={classnames(styles.containerPc, className)}>
        <div className="w-[1300px] pb-[16px] mx-auto mt-[80px]">
          {/* <Swiper slidesPerView="auto" centeredSlides loop={true} spaceBetween={16} navigation> */}
          <Swiper
            // onInit={(swiper) => {
            //   swiper.appendSlide(['<div class="swiper-slide" />'])
            // }}
            autoplay={{ delay: 6000 }}
            slidesPerView={3}
            centeredSlides
            loop={true}
            spaceBetween={16}
            navigation
            // grabCursor
            // effect="coverflow"
            // coverflowEffect={{
            //   rotate: 0,
            //   stretch: 0,
            //   depth: 0,
            //   modifier: 1,
            //   slideShadows: false,
            // }}
          >
            {section_one?.map((el, index) => {
              return (
                <SwiperSlide key={index}>
                  <a className="cursor-pointer block h-full" href={el?.btn_link} target="_blank">
                    <div className="content-container">
                      <div className="content-img">
                        <img
                          className="w-full min-h-[200px] rounded-[4px]"
                          src={el?.content_img?.publicURL || el?.content_img}
                          alt={el?.title}
                        />
                      </div>
                      <div className="px-[24px] py-[24px]">
                        <h4 className="text-[18px] font-medium leading-[24px] text-[#1f2d3d] content-title">
                          {el?.title}
                        </h4>
                        <p className="text-[14px] text-[#475669] leading-[20px]  content-desc ">{el?.desc}</p>
                        <p className="mt-[22px]">
                          <Button className="text-[14px]  text-[#04cb94] text-left" btnType="text">
                            {el?.btn_text}
                          </Button>
                          <span className="inline-block arrows-icon"></span>
                        </p>
                      </div>
                    </div>
                  </a>
                </SwiperSlide>
              )
            })}
          </Swiper>
          {btn_more_text && (
            <p className="mt-[50px] text-center">
              <Button btnType="primary" href={btn_more_link} target="_blank">
                {btn_more_text}
              </Button>
            </p>
          )}
        </div>
        {section_two && (
          <div className="h-[658px] w-full pt-[124px]   section-two ">
            <div className="w-[1200px]  mx-auto relative">
              <div className="background-plate h-[490px] w-[834px] "></div>
              <div className="absolute h-[368px] left-[40px] right-0 top-[50%] translate-y-[-50%] flex solution-content">
                <div className="text-content flex-1     h-full  relative">
                  <div>
                    <span className="inline-block  py-[2px] px-[8px] text-[12px] text-[#04CB94] bg-[rgba(4,203,148,0.1)] leading-[18px] rounded-[4px]">
                      最新行业调研
                    </span>
                  </div>
                  <div className="mt-[16px]">
                    <span className="text-[18px] font-medium leading-[24px] text-[#1F2D3D]">{section_two?.title}</span>
                  </div>
                  <p className="section-two-desc text-[14px] text-[#475669] leading-[24px] mt-[16px]  pr-[44px]">
                    {section_two?.desc}
                  </p>
                  <p className=" mt-[26px] ">
                    {section_two?.tag?.map((item, index) => {
                      return (
                        <span key={index} className="inline-block text-[14px] text-[#04cb94] tag-item">
                          {item}
                        </span>
                      )
                    })}
                  </p>
                  <p className="absolute left-[0] bottom-[30px]">
                    <Button btnType="primary" href={section_two?.btn_link} target="_blank">
                      {section_two?.btn_text}
                    </Button>
                  </p>
                </div>
                <div className="w-[640px] relative right-solutions-img">
                  <img
                    src={section_two?.right_img?.publicURL || section_two?.right_img}
                    className="w-full h-full rounded-[4px]"
                    alt={section_two?.title}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      {/* mb */}
      <div className={classnames(styles.containerMb, 'pt-[26px]', className)}>
        <div className="px-[20px] section-one">
          {section_one?.map((el, index) => {
            return (
              <a
                key={index + el?.title}
                className="bg-[#fff] rounded-[4px] mt-[10px] block"
                href={el?.btn_link}
                target="_blank"
              >
                {index === 0 && (
                  <div>
                    <img
                      className="w-full rounded-t-[4px]"
                      src={el?.content_img?.publicURL || el?.content_img}
                      alt={el?.title}
                    />
                  </div>
                )}
                <div className="px-[12px] pb-[20px] pt-[16px]">
                  <h4 className=" text-[16px] font-medium text-[#1f2d3d] leading-[22px] mb-content-desc !line-clamp-1">
                    {el?.title}
                  </h4>
                  <p
                    className={classnames('mt-[6px] text-[14px] text-[#475669] mb-content-desc', {
                      '!line-clamp-1': index !== 0,
                    })}
                  >
                    {el?.desc}
                  </p>
                </div>
              </a>
            )
          })}
          {btn_more_text && (
            <div className="text-center mt-[30px] pb-[52px]">
              <Button btnType="primary" href={btn_more_link} target="_blank">
                {btn_more_text}
              </Button>
            </div>
          )}
        </div>
        {section_two && (
          <div className="section-two px-[20px] pt-[40px] pb-[30px]">
            <div className="section-two-card-mb bg-[#fff]">
              <div className="relative">
                <img
                  src={section_two?.right_img?.publicURL || section_two?.right_img}
                  className="w-full h-full "
                  alt={section_two?.title}
                />
              </div>
              <div className="py-[20px] px-[5%]">
                <p>
                  <span className="inline-block  py-[2px] px-[8px] text-[12px] text-[#04CB94] bg-[rgba(4,203,148,0.1)] leading-[18px] rounded-[4px]">
                    最新行业调研
                  </span>
                </p>
                <p className="mt-[10px] text-[16px] font-medium text-[#1f2d3d] leading-[22px]">{section_two?.title}</p>
                <p className="mt-[4px] text-[14px] text-[#475669] leading-[24px] section-two-desc">
                  {section_two?.desc}
                </p>
              </div>
            </div>
            <div className="mt-[30px] text-center">
              <Button btnType="primary" href={section_two?.btn_link} target="_blank">
                {section_two?.btn_text}
              </Button>
            </div>
          </div>
        )}
      </div>
    </>
  )
}

export default CaseShare
